import { createFileRoute } from "@tanstack/react-router";
import { CrudTable } from "@/features/admin/components/CrudTable";

export const Route = createFileRoute("/_authenticated/admin/projects")({
  component: () => (
    <CrudTable
      title="Student Projects"
      table="projects"
      orderBy={{ column: "sort_order", ascending: true }}
      columns={[
        { key: "title", label: "Title" },
        { key: "student_name", label: "Student" },
        { key: "category", label: "Category" },
        { key: "is_published", label: "Published", render: (r) => (r.is_published ? "✅" : "❌") },
      ]}
      fields={[
        { key: "title", label: "Title", required: true },
        { key: "description", label: "Description", type: "textarea" },
        { key: "student_name", label: "Student Name" },
        { key: "student_age", label: "Student Age", type: "number" },
        { key: "category", label: "Category (game/website/ai/robotics/animation)" },
        { key: "image_url", label: "Image URL" },
        { key: "project_url", label: "Project URL" },
        { key: "sort_order", label: "Sort Order", type: "number" },
        { key: "is_published", label: "Published", type: "switch", defaultValue: true },
      ]}
    />
  ),
});
